module.exports = __webpack_public_path__ + "static/media/recharging-your-battery-large@2x.db7a8e04.png";